import React from 'react'
import { Link } from 'react-router-dom'
import slider2 from '../../../../assets/img/slider2.webp'

function SliderAbout2Sec1() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Perfecting a highly streamlined and agile development process</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Perfecting a highly streamlined and <span>agile development process</span></h2>
              <p>At 360 Gigabytes, we take pride in our commitment to excellence and efficiency. Our team follows a <b>meticulously streamlined and agile development process</b>, designed to deliver rapid results without ever compromising on the high standards of quality. We understand the importance of <b>both speed and precision</b> in today's fast-paced IT landscape. With our approach, you can trust that your projects will not only be completed promptly but also with the utmost attention to detail, ensuring your success in the digital world.</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider2} alt='Perfecting a highly streamlined and agile development process' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default SliderAbout2Sec1
